var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPressureVeryHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9937 12.2151C13.2293 12.2151 11.7991 13.6454 11.7991 15.4097C11.7991 17.174 13.2293 18.6043 14.9937 18.6043C16.758 18.6043 30.1882 15.4097 30.1882 15.4097C30.1882 15.4097 16.758 12.2151 14.9937 12.2151Z",
    fill: "#FF7A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8682 13.0012C28.9946 6.43401 23.872 1.20952 17.3547 0.181944L17.355 0.183801C16.5878 0.0628193 15.8012 0 15 0C14.2031 0 13.4207 0.0621438 12.6574 0.18185L12.6577 0.179993C5.48597 1.30459 0 7.51073 0 14.9982V15C0 18.0185 0.891608 20.8288 2.42583 23.1818C2.76937 23.7087 3.36899 24 3.998 24H26.002C26.631 24 27.2306 23.7087 27.5742 23.1818C28.6181 21.5807 29.3645 19.7679 29.735 17.8218L27.3767 18.1527C27.0557 19.4379 26.5396 20.6459 25.8619 21.7435H4.13802C3.00836 19.914 2.32798 17.7777 2.25078 15.4885C2.24592 15.3438 2.24347 15.1984 2.24347 15.0525C2.24347 12.6067 2.93179 10.3217 4.12527 8.38052L4.12463 8.37967C5.07735 6.82981 6.3521 5.49914 7.85568 4.48087L7.85697 4.48185C9.89504 3.10194 12.3534 2.29596 15 2.29596C21.2336 2.29596 26.4228 6.76704 27.5358 12.6772L29.8682 13.0012Z",
    fill: "white",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressureVeryHigh);
export default __webpack_public_path__ + "static/media/pressure_very_high.debc800d18a1e2833a5738bc9582d513.svg";
export { ForwardRef as ReactComponent };